export default __webpack_public_path__ + "static/char-s-55-ko-3a978b69e3470add1e2cf63d3d1d3b3f.webp";